import { NuevosUsuarios } from '../NuevosUsuarios';

const NuevosUsuariosPage = () => <NuevosUsuarios />;

export default NuevosUsuariosPage;
